import React from 'react';

import { CoreLink, View } from '@uncinc/react-drupal-core';
import { Container, WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

const AgendaUpcoming = ({ entity }) => {
  const title = entity.getIn(['field_title', 0, 'value']);
  const body = entity.getIn(['field_body', 0, 'processed']);
  const linkTitle = entity.getIn(['field_link', 0, 'title']);
  const linkUri = entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri']));

  return (
    <Container>
      <div className="Paragraph AgendaUpcoming">
        <div className="AgendaUpcoming__content">
          {title && <h2>{title}</h2>}
          {body && (
            <WysiwygField
              className="AgendaUpcoming__content__intro subheading2"
              property="schema:text"
              html={body}
            />
          )}
        </div>
        <View id="agenda" display="upcoming" />
        <div className="AgendaUpcoming__link_wrapper">
          {linkUri && linkTitle && (
            <div className="AgendaUpcoming__link">
              <CoreLink to={linkUri} className="Button Button--ghost">
                {linkTitle}
                <div className="icon icon-chevron-right" />
              </CoreLink>
            </div>
          )}
        </div>
      </div>
    </Container>
  );
};

export default AgendaUpcoming;
